module.exports = __webpack_public_path__ + "img/christian.81864d91.svg";